<div class="hero-section">
    <!-- Simplified banner section -->
    <div *ngIf="bannerData" [ngClass]="bannerData.class" [style.background-image]="bannerData.bgImage">
        <div class="container">
            <div class="row">
                <div class="col-xl-5 col-lg-6 col-md-7 ms-auto">
                    <div class="card Pre-Qualify">
                        <h3 [innerHTML]="bannerData.title"></h3>
                        <h5 [innerHTML]="bannerData.subtitle"></h5>
                        <div *ngIf="bannerData.showButtons" class="d-flex align-items-center justify-content-between mt-3 flex-wrap flex-md-nowrap gap-2">
                            <button *ngIf="bannerData.button1" class="btn primary-btn" (click)="gotoCXUrl()">{{ bannerData.button1 }}</button>
                            <ng-container *ngIf="hasCliSubProduct && bannerData.button3">
                                <button class="btn primary-btn" (click)="gotoCXUrlForCliSubProduct()">{{ bannerData.button3 }}</button>
                            </ng-container>
                            <button *ngIf="bannerData.button2" class="btn text-white white-bold work-link" (click)="openFAQModal()">{{ bannerData.button2 }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="tabs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 px-0">
                <ul ngbNav #cardsNav="ngbNav" class="nav-tabs" [(activeId)]="activeNavTab">
                    <li class="nav-item" [ngbNavItem]="1" *ngIf="personalCC.length > 0" (click)="setLoanPurpose('CC')">
                        <button ngbNavLink>Personal Cards</button>

                        <ng-template ngbNavContent>
                            <ng-container [ngTemplateOutlet]="cardListTemplate"
                                          [ngTemplateOutletContext]="{cardList: personalCC}"></ng-container>
                        </ng-template>
                    </li>
                    <li class="nav-item" [ngbNavItem]="2"
                        *ngIf="allBusinessCC.length > 0 || allBusinessCCCharge.length > 0"
                        (click)="selectBusinessCardType()">
                        <button ngbNavLink>Business Cards</button>

                        <ng-template ngbNavContent>
                            <ng-container [ngTemplateOutlet]="cardListTemplate"
                                          [ngTemplateOutletContext]="{cardList: businessCC}"></ng-container>
                        </ng-template>
                    </li>
                </ul>

                <div class="tab-content" id="myTabContent" [ngbNavOutlet]="cardsNav"></div>
            </div>
        </div>
    </div>
</div>


<div class="pre-footer py-md-4 py-sm-4 py-2" *ngIf="loanPurpose === 'CC'">
    <ng-container *ngIf="preFooterIcons.length > 0; else defaultIcons">
        <div class="container">
            <div class="row">
                <div class="col" *ngFor="let item of preFooterIcons">
                    <div class="pre-footer-box">
                        <div class="img-wrapper">
                            <img [src]="item.icon" alt="">
                        </div>
                        <h6>{{ item.text }}</h6>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #defaultIcons>
        <div class="container">
        <div class="row">
            <div class="col-md-4 col-sm-6">
            <div class="pre-footer-box">
                <div class="img-wrapper">
                <img src="/assets/image/fico-icon.svg" alt="">
                </div>
                <h6>No impact to your credit score.</h6>
            </div>
            </div>

            <div class="col-md-4 col-sm-6">
            <div class="pre-footer-box">
                <div class="img-wrapper">
                <img src="/assets/image/card-icon.svg" alt="">
                </div>
                <h6>Find a card that fits your needs.</h6>
            </div>
            </div>

            <div class="col-md-4 col-sm-6">
            <div class="pre-footer-box">
                <div class="img-wrapper">
                <img src="/assets/image/timer-icon.svg" alt="">
                </div>
                <h6>Takes less than a minute.</h6>
            </div>
            </div>
        </div>
        </div>
    </ng-template>
</div>
<div class="pre-footer py-md-4 py-sm-4 py-3" *ngIf="loanPurpose !== 'CC'">
    <ng-container *ngIf="preFooterIcons.length > 0; else defaultIcons">
        <div class="container">
            <div class="row">
                <div class="col" *ngFor="let item of preFooterIcons">
                    <div class="pre-footer-box">
                        <div class="img-wrapper">
                            <img [src]="item.icon" alt="">
                        </div>
                        <h6>{{ item.text }}</h6>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #defaultIcons>
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <div class="pre-footer-box">
                        <div class="img-wrapper">
                            <img src="/assets/image/Expense-icon.svg" alt="">
                        </div>
                        <h6>Expense Management Tools</h6>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6">
                    <div class="pre-footer-box">
                        <div class="img-wrapper">
                            <img src="/assets/image/cost-employe-icon.svg" alt="">
                        </div>
                        <h6>No Cost Employee Cards</h6>
                    </div>
                </div>

                <div class="col-md-4 col-sm-6">
                    <div class="pre-footer-box">
                        <div class="img-wrapper">
                            <img src="/assets/image/fraud-monitoring-Icon.svg" alt="Takes less than a minute.">
                        </div>
                        <h6>Fraud Monitoring and Alerts</h6>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
<div class="footer-btn py-md-4 py-3">
    <div class="container">
        <div class="row" *ngIf="loanPurpose === 'CC'">
            <div class="col-12">
                <div class="text-center">
                    <!-- <h4 class="mb-3" (click)="gotoCXUrl()">See if I Pre-Qualify</h4>-->
                    <button class="btn primary-btn" (click)="gotoCXUrl()">Get Started</button>
                </div>
            </div>
        </div>

        <ng-content>
            <div *ngIf="appConfig.homeBottomText && loanPurpose == 'CC'" [innerHTML]="appConfig.homeBottomText"></div>
        </ng-content>
        <!--<div *ngIf="loanPurpose == 'CC'">
            <hr class="grey-line">
            <p class="footer-text mt-0 mb-0 fw-medium fz"><b class="head-color">USA PATRIOT ACT</b><br>
                IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT<br>
                To help the government fight the funding of terrorism and money laundering activities, Federal law
                requires all financial institutions to obtain, verify, and record information that identifies each
                person who opens an account. What this means for you: When you open an account, we will ask for your
                name, address, date of birth, and other information that will allow us to identify you. We may also ask
                to see your driver's license or other identifying documents.</p>
            <p class="footer-text mt-0 mb-0 fw-medium fz mt-3"><b class="head-color">MILITARY LENDING ACT</b><br>
                Important disclosures about the Military Lending Act will be provided with your card. If you would like
                information now, please contact us at 1-800-883-0131.</p>
        </div>-->
        <div class="row" *ngIf="!appConfig.hideRewardsDisclosure && showRewardsDisclosure">
            <div class="col-md-12 text-center mt-2">
                <span><sup>1</sup>Account must be open and in good standing to access rewards.</span><br>
            </div>
        </div>
    </div>
</div>


<ng-template #cardListTemplate let-cardList="cardList">
    <div class="container">
        <div class="row pt-5">
            <div class="skeleton row" *ngIf="cardList.length <= 0">
                <div class="col-md-4 col-sm-6 p-2" *ngFor="let card of skeletonCards">
                    <div class="skeleton-card pt-2 pb-3">
                        <div class="skeleton-card-image"></div>
                        <div class="skeleton-card-content py-3">
                            <h2></h2>
                            <p></p>
                            <button class="btn"></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-sm-6 p-2" *ngFor="let card of cardList">
                <div class="py-3 card-box d-flex flex-column h-100">
                    <div class="img-wrapper">
                        <img [src]="card.imageUrl" class="card-img-top" alt="Visa Card">
                    </div>
                    <div class="card-content px-2 text-center d-flex flex-column h-100">
                        <h2 [innerHTML]="card.name"></h2>
                        <div class="card-body d-flex flex-column justify-content-between">
                            <ul class="card-details p-0">
                                <li [innerHTML]="card.subTitle"></li>
                                <!--                            <li> {{card.shortInfo}}</li>-->
                                <!-- Add more details here as needed -->
                            </ul>
                            <div class="text-center">
                                <a [routerLink]="['/card-detail/', loanPurpose, card.id]"
                                   [queryParams]="{merchantId:merchantId}"
                                   target="_blank">Learn More</a>
                                <br>
                                <button class="apply-btn btn" (click)="gotoCXUrl()"
                                        *ngIf="loanPurpose === 'BCC'|| loanPurpose === 'BCC_CHARGE'">Apply Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #popupContent let-modal>
    <div class="modal-header p-0">
        <h5 class="modal-title p-3 pb-2 fw-semibold">Let’s find the right card for your business.</h5>
    </div>
    <div class="modal-body p-0">
        <p class="p-3 pb-0 fw-medium">Please select a statement that applies to your business:</p>
        <ul class="list-unstyled business-option-list">
            <li class="d-flex px-3 py-2" (click)="updateAccountType('BCC_CHARGE')">
                <span class="circle"></span>
                <div>
                    <button class="fw-semibold">My business is a non-profit or a municipality</button>
                    <br>
                    <small>Example: church, fire station, school, etc.</small>
                </div>
            </li>
            <li class="d-flex px-3 py-2" (click)="updateAccountType('BCC_CHARGE')">
                <span class="circle"></span>
                <button class="fw-semibold">My business has 50+ employees or has annual revenues greater than
                    $7million
                </button>
            </li>
            <li class="d-flex px-3 py-2" (click)="updateAccountType('BCC')">
                <span class="circle"></span>
                <button class="fw-semibold">None of the statements apply to my business</button>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #faqContent let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Frequently Asked Questions</h5>
    </div>
    <div class="modal-body">
        <div ngbAccordion id="faq-accordion" [closeOthers]="true">
            <div *ngFor="let faq of faqItems; let i = index" [id]="'faq-' + (i+1)" ngbAccordionItem>
                <div ngbAccordionHeader>
                    <button ngbAccordionButton class="text-decoration-underline">
                        {{ faq.question }}
                    </button>
                </div>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>{{ faq.answer }}</ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>
